import { useCallback, useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import type { RecipeUUID } from '@library/menu-service'

import { incrementTutorialViewed } from 'actions/tutorial'
import { useBasket } from 'routes/Menu/domains/basket'
import { useIsTutorialPending } from 'routes/Menu/hooks/useIsTutorialPending'
import { getIsAuthenticated } from 'selectors/auth'

export const useRecipeGridFlexEducation = () => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(getIsAuthenticated)
  const isFlexEducationPending = useIsTutorialPending('flex-education-tooltip')
  const { recipeCount } = useBasket()
  const [flexEducationRecipeId, setFlexEducationRecipeId] = useState<RecipeUUID | null>(null)

  const onRecipeAdded = useCallback(
    (recipeId: RecipeUUID) => {
      if (isAuthenticated && isFlexEducationPending && recipeCount === 0) {
        setFlexEducationRecipeId(recipeId)
      }
    },
    [isFlexEducationPending, isAuthenticated, recipeCount],
  )

  const closeFlexEducationTooltip = useCallback(() => {
    dispatch(incrementTutorialViewed('flex-education-tooltip'))
    setFlexEducationRecipeId(null)
  }, [dispatch])

  useEffect(() => {
    if (recipeCount !== 1) {
      setFlexEducationRecipeId(null)
    }
  }, [recipeCount])

  const visibleFlexEducationRecipeId =
    isAuthenticated && isFlexEducationPending && recipeCount === 1 ? flexEducationRecipeId : null

  return {
    closeFlexEducationTooltip,
    flexEducationRecipeId: visibleFlexEducationRecipeId,
    onRecipeAdded,
  }
}
